import CompanyUser, {
  CompanyUserFormSend,
  CompanyUserFormUpdate,
} from "@/interfaces/CompanyUser";
import api from "../api";
import { IPaginateResponse } from "@/interfaces/Fetch";
import { UserFilters } from "@/interfaces/IUser";

export const companyUsersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyUsers: build.query<
      IPaginateResponse<CompanyUser>,
      [string, UserFilters]
    >({
      query: ([companyId, params]) => ({
        url: `/companies/${companyId}/users`,
        params,
      }),
      providesTags: (_, __, companyId) => [
        { type: "CompanyUsers", companyId, id: "LIST" },
      ],
    }),
    deleteCompanyUser: build.mutation<void, [string, string]>({
      query: ([companyId, userId]) => ({
        url: `/companies/${companyId}/users/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, _error, [companyId]) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "CompanyUsers", companyId, id: "LIST" },
      ],
    }),
    getCompanyUser: build.query<CompanyUser, [string, string]>({
      query: ([companyId, userId]) => ({
        url: `/companies/${companyId}/users/${userId}`,
      }),
      providesTags: (_, __, [companyId, userId]) => [
        { type: "CompanyUsers", companyId, id: userId },
      ],
    }),
    updateCompanyUser: build.mutation<
      void,
      [string, string, CompanyUserFormUpdate]
    >({
      query: ([companyId, userId, body]) => ({
        url: `/companies/${companyId}/users/${userId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_, _error, [companyId]) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "CompanyUsers", companyId, id: "LIST" },
      ],
    }),
    storeCompanyUser: build.mutation<void, [string, CompanyUserFormSend]>({
      query: ([companyId, body]) => ({
        url: `/companies/${companyId}/users`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_, _error, [companyId]) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "CompanyUsers", companyId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useDeleteCompanyUserMutation,
  useStoreCompanyUserMutation,
  useGetCompanyUsersQuery,
  useUpdateCompanyUserMutation,
  useGetCompanyUserQuery,
  useLazyGetCompanyUserQuery,
} = companyUsersApi;
